
    import { h } from 'vue';
    import { normalizeSlotChildren } from '@/Utils/SlotUtility';

    export default {
        props: {
            description: { type: String, default: null },
            showDivider: { type: Boolean, default: true },
            title: { type: String, default: null },
        },
        render() {
            const { class: attrsClass, ...attrs } = this.$attrs;
            const elements = [];

            if (this.showDivider) {
                elements.push(h('div', { class: 'gfu-hr' }));
            }
            if (this.title) {
                elements.push(h('span', { class: 'gfu-hd gfu-hd--h1' }, this.title));
            }
            if (this.description) {
                elements.push(h('span', { class: 'gfu-bt gfu-bt--b2 _mt-3 _mb-3' }, this.description));
            }
            elements.push(...normalizeSlotChildren(this.$slots.default));

            return h(
                'div',
                { ...attrs, class: ['gfu-empty-state', attrsClass] },
                elements);
        },
    };
